export interface Education {
  institution: string;
  qualification: string;
  result: string;
  startDate: Date;
  endDate: Date;
  location: string;
  additionalInformation: string;
  key: string;
}

export const education: Education[] = [
  {
    institution: 'VESIT Mumbai University',
    qualification: 'B.E Computer Science ',
    result: '',
    startDate: new Date(2016, 6),
    endDate: new Date(2020, 6),
    location: 'Chembur',
    additionalInformation: '',
    key:''
  },
  {
    institution: 'NAHATA College',
    qualification: 'HSC - Science',
    result: '',
    startDate: new Date(2014, 6),
    endDate: new Date(2020, 6),
    location: 'Bhusawal',
    additionalInformation: '',
    key:''
  }
];
